import { Theme } from '@mui/material'
import { MUIThemeColors } from 'src/mui-theme'
import { getThemeColor } from 'src/utils'

export const POSITION_DRAWING_ROW_HEIGHT = 44
export const POSITION_DRAWING_HEADER_HEIGHT = 36

export const getPositionDrawingTableSx = (theme: Theme) => ({
  border: 'none',
  minHeight: '52px',
  '& .MuiDataGrid-columnHeaders': {
    backgroundColor: getThemeColor(theme, MUIThemeColors.backgroundMain),
    minHeight: `${POSITION_DRAWING_HEADER_HEIGHT}px !important`,
    maxHeight: `${POSITION_DRAWING_HEADER_HEIGHT}px !important`,
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  '& .MuiDataGrid-columnHeader': {
    px: 1,
    '&:focus, &:focus-within': { outline: 'none' },
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    fontSize: '14px',
    letterSpacing: '0.4px',
  },
  '& .MuiDataGrid-row': {
    minHeight: `${POSITION_DRAWING_ROW_HEIGHT}px !important`,
    maxHeight: `${POSITION_DRAWING_ROW_HEIGHT}px !important`,
  },
  '& .MuiDataGrid-cell': {
    py: 0,
    px: 1,
    borderBottom: `1px solid ${theme.palette.divider}`,
    alignItems: 'center',
    display: 'flex',
    '&:focus, &:focus-within': { outline: 'none' },
  },
  '& .MuiDataGrid-cell--withRenderer': {
    alignItems: 'center',
  },
  '& .MuiDataGrid-footerContainer': {
    minHeight: 40,
    borderTop: `1px solid ${theme.palette.divider}`,
  },
})
